var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list",
    _vm._b({ attrs: { dense: "" } }, "v-list", _vm.$attrs, false),
    [
      _vm.subtitle
        ? _c("v-subheader", [
            _c("span", { staticClass: "text-caption" }, [
              _vm._v(_vm._s(_vm.subtitle)),
            ]),
          ])
        : _vm._e(),
      _c(
        "v-list-item-group",
        {
          attrs: { color: _vm.color },
          model: {
            value: _setup.selected,
            callback: function ($$v) {
              _setup.selected = $$v
            },
            expression: "selected",
          },
        },
        _vm._l(_setup.localItems, function (item, i) {
          return _c(
            "v-list-item",
            {
              key: i,
              on: {
                click: function ($event) {
                  return _setup.emit("on-select", item)
                },
              },
            },
            [
              _c(
                "v-list-item-content",
                [
                  _c(
                    "v-list-item-title",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "span",
                                      _vm._g(
                                        _vm._b({}, "span", attrs, false),
                                        on
                                      ),
                                      [_vm._v(_vm._s(item[_vm.column]))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [_c("span", [_vm._v(_vm._s(item[_vm.column]))])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }